export default __webpack_public_path__ + "static/tools-0436a2102e40b865f037b9cfccda559b.png";